var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
ConfirmationBanner.OverlayView = function (superClass) {
  extend(OverlayView, superClass);
  function OverlayView() {
    return OverlayView.__super__.constructor.apply(this, arguments);
  }
  OverlayView.defaultFadeout = 1500;
  OverlayView.fadeInTime = 250;
  OverlayView.fadeOutTime = 500;
  OverlayView.prototype.jstTemplate = "confirmation_banner/templates/overlay_view";
  OverlayView.prototype.events = {
    "click .close": "closeWasClicked",
    "click .actions .action": "actionWasClicked"
  };
  OverlayView.prototype.initialize = function (options) {
    this.message = options.message;
    this.actions = options.actions || {};
    this.fadeout = options.fadeout;
    if (this.fadeout === true) {
      return this.fadeout = ConfirmationBanner.OverlayView.defaultFadeout;
    }
  };
  OverlayView.prototype.closeWasClicked = function (ev) {
    return this.close();
  };
  OverlayView.prototype.actionWasClicked = function (ev) {
    this.actions[$(ev.target).data("action")]();
    return this.close();
  };
  OverlayView.prototype.render = function () {
    $("#site").before(this.$el.html(JST[this.jstTemplate]({
      message: this.message,
      actions: _.keys(this.actions)
    })).fadeIn(ConfirmationBanner.OverlayView.fadeInTime));
    if (this.fadeout) {
      return this.$el.delay(this.fadeout).fadeOut(ConfirmationBanner.OverlayView.fadeOutTime);
    }
  };
  OverlayView.prototype.close = function () {
    return this.$el.fadeOut(ConfirmationBanner.OverlayView.fadeOutTime);
  };
  return OverlayView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;